import React, { Component } from 'react';
import Dygraph from 'dygraphs/index.es5';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';

import * as slowDataReducers from '../../slow-data/reducer';
import * as Reducers from '../reducer';

import * as fastDataActionManager from '../../fast-data/action-mgr';
import * as fastDataReducerManager from '../../fast-data/reducer';

import * as strings from '../../helpers/strings';
import { Paper } from '@material-ui/core';

const styles = {
  graphCol: { height: 640, position: "relative" },
  graphBG: { background: "linear-gradient(0deg, #343A40, 0.4%, #F8F8F8 0.4%)", padding: '25px', height: '100%'},
  graph: {
    position: "absolute",
    left: 0,
    right: 45,
    top: 40,
    bottom: 10,
    height: 580,
  },
  '@global': {
    '#stationFastData Button': {
      display: 'none',
    }
  }
}

let dataSource = [];
let checkParameter = 0;
let selectStation = ""

class DMYLineGraph extends Component {

  componentWillUnmount() {
    window.ipaDyLineGraph = null;
    dataSource = [];
  }

  componentDidMount() {
    let options = {
      labels: [],
      strokeWidth: 3,
      highlightSeriesOpts: { 
        highlightCircleSize: 5,
        strokeWidth: 3.5
      },
      legend: 'always',
      labelsDiv: "legend",
      fillGraph: "True", 
      fillAlpha: 0.3
    };

    var graphElement = document.getElementById(strings.idIPAGraph);
    window.ipaDyLineGraph = new Dygraph(graphElement, [[new Date(), 0]], options);  // Add initial non-empty dataset
  }

  shouldComponentUpdate(nextProps) {
    const { getAllLastData, getSelectFieldsIndex, selectedField, selectedStationId } = nextProps;
    let stnParameter = ['Time']

    // if (dataSource.length > 7200) {
    //   dataSource.shift()
    // }

    if (selectedStationId !== selectStation) {
      dataSource = []
      selectStation = selectedStationId
    }

    if (checkParameter !== getSelectFieldsIndex.length) {
      checkParameter = getSelectFieldsIndex.length;
      dataSource = []
    }

    if (getAllLastData !== null && getAllLastData.Data) {

      let currentTime = new Date();
      let cleanArrayNumber = [new Date(currentTime.toString())]
      if (getAllLastData) {
        getSelectFieldsIndex.forEach(fieldIndex => {
          cleanArrayNumber.push(getAllLastData.Data[parseInt(fieldIndex - 1, 10)] / 10)
        })
      }

      dataSource.push(cleanArrayNumber);

      window.ipaDyLineGraph.updateOptions({
        file: dataSource,
        labels: stnParameter.concat(selectedField),
      });
    }
    return false;
  }

  render() {
    const { classes } = this.props;

    return (
      <Paper className={classes.graphBG}>
        <div className={classes.graphCol} id="stationFastData">
            <div id="legend"></div>
            <div id={strings.idIPAGraph} style={{ width: '100%', position: 'relative', height: '95%' }} />
        </div>
      </Paper>

    )
  }
}
const mapActionsToProps = {
  addFastData: fastDataActionManager.addFastData,
}

const mapStateToProps = state => ({

  getFindStationRealtimeFields: Reducers.getFindStationRealtimeFields(state),
  getSelectFieldsIndex: Reducers.getSelectFieldsIndex(state),
  selectedField: Reducers.getSelectedField(state),

  findStationFields: slowDataReducers.getFindStationFields(state),
  selectedStationId: slowDataReducers.getStationId(state),
  dataSource: slowDataReducers.getGraphDataSourceV2(state),

  getAllLastData: fastDataReducerManager.getAllLastData(state),
})

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(DMYLineGraph)
);